module.exports = __webpack_public_path__ + "img/audition.ebebe12a.png";